import { WidgetImplementations } from '../../../components/dashboards/Widget';

const defaultWidgetSettingsByType = {};

for (const [key, clazz] of Object.entries(WidgetImplementations)) {
  defaultWidgetSettingsByType[key] = clazz.defaultSettings || {};
}

export default defaultWidgetSettingsByType;
